import React from "react";
import { useTranslation } from "react-i18next";

export default function ScenarioSwitcher({ scenarios, runs, selected, onSelect }) {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="scenario-switcher">
      {scenarios.map((s) => (
        <button key={s.key} data-testid={`scenario-tab-${s.key}`} onClick={() => onSelect(s)}
          aria-pressed={selected?.run_id === s.run_id}
          className={`px-3 py-1.5 rounded-lg text-xs font-medium border transition-colors ${
            selected?.run_id === s.run_id
              ? "bg-[var(--qn-primary-muted)] border-[var(--qn-border-active)] text-[var(--qn-primary)]"
              : "border-[var(--qn-border)] text-[var(--qn-foreground-muted)] hover:text-[var(--qn-foreground)]"}`}>
          {s.label}
        </button>
      ))}
      {runs.length > 0 && (
        <select data-testid="run-picker"
          className="bg-[var(--qn-card)] border border-[var(--qn-border)] rounded-lg text-xs px-2 py-1.5 text-[var(--qn-foreground-muted)]"
          value={selected?.run_id && runs.some((r) => r.run_id === selected.run_id) ? selected.run_id : ""}
          onChange={(e) => {
            const r = runs.find((x) => x.run_id === e.target.value);
            if (r) onSelect({ run_id: r.run_id, label: `${r.module_id || "run"} · ${r.run_id.slice(0, 12)}`, module_id: r.module_id, key: r.run_id });
          }}>
          <option value="">{t("decisionGraph.otherRuns")}</option>
          {runs.map((r) => (
            <option key={r.run_id} value={r.run_id}>{(r.module_id || "run")} · {r.run_id.slice(0, 12)} · {r.status}</option>
          ))}
        </select>
      )}
    </div>
  );
}
